"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACPrint = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var RefProvider_1 = require("../context/RefProvider");
var ACPrint = function (props) {
    var sharedRef = (0, react_1.useContext)(RefProvider_1.RefContext);
    // console.log('sharedRef in ACPrint:', sharedRef);
    return ((0, jsx_runtime_1.jsx)("div", { ref: sharedRef, className: props.className, children: props.renderFields(props.fields) }));
};
exports.ACPrint = ACPrint;
